var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaAlertsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2171 53.5H23.7829C22.7453 53.5 22.1719 52.3999 22.7066 51.5993L24.5878 48.7827C25.3467 47.6465 25.7514 46.3189 25.7514 44.9611V35C25.7514 28.1089 31.492 22.5 38.6014 22.5H40.3986C47.508 22.5 53.2486 28.1089 53.2486 35V44.9611C53.2486 46.3189 53.6533 47.6465 54.4122 48.7827L56.2934 51.5993C56.8281 52.3999 56.2547 53.5 55.2171 53.5Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "url(#paint0_radial_20745_219)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1516 21.988H4V51.5H44V15.9082H37.9997L31 3.5L17 29L11.1516 21.988Z",
    fill: "url(#paint1_linear_20745_219)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.988H10.2154C10.8086 21.988 11.3713 22.2514 11.7512 22.707L16.061 27.8742C16.5122 28.4152 17.3665 28.3325 17.7055 27.7149L30.1353 5.07504C30.5125 4.38793 31.4977 4.38225 31.8828 5.06498L37.4258 14.8909C37.7803 15.5195 38.446 15.9082 39.1677 15.9082H44",
    stroke: "#FF0508",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2171 53.5H23.7829C22.7453 53.5 22.1719 52.3999 22.7066 51.5993L24.5878 48.7827C25.3467 47.6465 25.7514 46.3189 25.7514 44.9611V35C25.7514 28.1089 31.492 22.5 38.6014 22.5H40.3986C47.508 22.5 53.2486 28.1089 53.2486 35V44.9611C53.2486 46.3189 53.6533 47.6465 54.4122 48.7827L56.2934 51.5993C56.8281 52.3999 56.2547 53.5 55.2171 53.5Z",
    fill: "url(#paint2_linear_20745_219)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2171 53.5H23.7829C22.7453 53.5 22.1719 52.3999 22.7066 51.5993L24.5878 48.7827C25.3467 47.6465 25.7514 46.3189 25.7514 44.9611V35C25.7514 28.1089 31.492 22.5 38.6014 22.5H40.3986C47.508 22.5 53.2486 28.1089 53.2486 35V44.9611C53.2486 46.3189 53.6533 47.6465 54.4122 48.7827L56.2934 51.5993C56.8281 52.3999 56.2547 53.5 55.2171 53.5Z",
    fill: "url(#paint3_radial_20745_219)",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2171 53.5H23.7829C22.7453 53.5 22.1719 52.3999 22.7066 51.5993L24.5878 48.7827C25.3467 47.6465 25.7514 46.3189 25.7514 44.9611V35C25.7514 28.1089 31.492 22.5 38.6014 22.5H40.3986C47.508 22.5 53.2486 28.1089 53.2486 35V44.9611C53.2486 46.3189 53.6533 47.6465 54.4122 48.7827L56.2934 51.5993C56.8281 52.3999 56.2547 53.5 55.2171 53.5Z",
    fill: "url(#paint4_radial_20745_219)",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2171 53.5H23.7829C22.7453 53.5 22.1719 52.3999 22.7066 51.5993L24.5878 48.7827C25.3467 47.6465 25.7514 46.3189 25.7514 44.9611V35C25.7514 28.1089 31.492 22.5 38.6014 22.5H40.3986C47.508 22.5 53.2486 28.1089 53.2486 35V44.9611C53.2486 46.3189 53.6533 47.6465 54.4122 48.7827L56.2934 51.5993C56.8281 52.3999 56.2547 53.5 55.2171 53.5Z",
    stroke: "url(#paint5_radial_20745_219)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43 54.5C43 54.9596 42.9095 55.4148 42.7336 55.8394C42.5577 56.264 42.2999 56.6499 41.9749 56.9749C41.6499 57.2999 41.264 57.5577 40.8394 57.7336C40.4148 57.9095 39.9596 58 39.5 58C39.0404 58 38.5852 57.9095 38.1606 57.7336C37.736 57.5577 37.3501 57.2999 37.0251 56.9749C36.7001 56.6499 36.4423 56.264 36.2664 55.8394C36.0905 55.4148 36 54.9596 36 54.5L39.5 54.5H43Z",
    fill: "url(#paint6_linear_20745_219)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 29,
    r: 5,
    fill: "#88A2B1",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 27,
    r: 5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20745_219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5769 5.17308) rotate(55.5392) scale(41.633 41.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20745_219",
    x1: 24,
    y1: 5.84146,
    x2: 24,
    y2: 49.1585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0508",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20745_219",
    x1: 23.0937,
    y1: 22.875,
    x2: 52.8371,
    y2: 54.6848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_20745_219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30 25.5) rotate(48.5035) scale(17.3566 16.0804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_20745_219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22 22) scale(35 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20745_219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5769 5.17308) rotate(55.5392) scale(41.633 41.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20745_219",
    x1: 31.5,
    y1: 46,
    x2: 44.1744,
    y2: 57.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633123,
    stopColor: "#C1C1D1",
    stopOpacity: 0.487338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaAlertsLogo);
export default __webpack_public_path__ + "static/media/megaAlertsLogo.1c4333c26ff6ad01ae49c9531e478fbd.svg";
export { ForwardRef as ReactComponent };